module.exports = __webpack_public_path__ + "img/zlindex80.db7cf5a2.png";